




















import { defineComponent, ref } from '@vue/composition-api';
import svgCom from '@components/Svg/index';
import TCaptcha from '@components/TCaptcha/index.vue';
import DialogCom from '@/components/Dialog/index';

export default defineComponent({
  name: 'HelloWorld',
  props: {
    msg: String,
  },
  components: {
    svgCom,
    TCaptcha,
    DialogCom,
  },
  setup() {
    const showDialog = ref(false);

    const handleClick = () => {
      showDialog.value = !showDialog.value;
    };

    const closeDialog = () => {
      showDialog.value = false;
    };

    return { showDialog, handleClick, closeDialog };
  },
});
